import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Dumbbell, LayoutGrid, Settings } from 'lucide-react';

const items = [
  { to: '/home', icon: Home, label: 'Home', id: 'nav-home' },
  { to: '/presets', icon: LayoutGrid, label: 'Presets', id: 'nav-presets' },
  { to: '/builder', icon: Dumbbell, label: 'Builder', id: 'nav-builder' },
  { to: '/settings', icon: Settings, label: 'Settings', id: 'nav-settings' },
];

export const BottomNavigation = () => {
  const location = useLocation();
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 mx-auto max-w-2xl px-4 pb-4"
      aria-label="Primary"
    >
      <div className="ns-glass flex items-center justify-around rounded-[26px] px-2 py-2">
        {items.map(({ to, icon: Icon, label, id }) => {
          const active = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={id}
              aria-label={label}
              className="relative flex flex-1 flex-col items-center gap-1 rounded-2xl py-2"
            >
              {active && (
                <motion.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-2xl bg-[#38BDF8]/15"
                  transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                />
              )}
              <Icon
                size={22}
                className="relative z-10 transition-colors"
                color={active ? '#38BDF8' : '#CBD5E1'}
              />
              <span
                className="relative z-10 text-[10px] font-semibold"
                style={{ color: active ? '#38BDF8' : '#CBD5E1' }}
              >
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
